import { __decorate, __extends } from "tslib";
import { proxyTo } from '../utils/FilterUtils';
import { BlurFilter } from './BlurFilter';
import { BevelTask } from './tasks/webgl/BevelTask';
var BevelFilter = /** @class */ (function (_super) {
    __extends(BevelFilter, _super);
    function BevelFilter(options) {
        var _this = _super.call(this, options) || this;
        _this._bevelTask = new BevelTask();
        _this.distance = 1;
        _this.angle = 45;
        _this.highlightColor = 0xffffff;
        _this.highlightAlpha = 1;
        _this.shadowColor = 1;
        _this.shadowAlpha = 0;
        _this.strength = 1;
        _this.type = 'inner';
        _this.knockout = false;
        _this.addTask(_this._bevelTask);
        _this.applyProps(options);
        return _this;
    }
    BevelFilter.prototype.applyProps = function (model) {
        // run all model field that changed
        for (var key in model) {
            this[key] = model[key];
        }
    };
    BevelFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManager) {
        _super.prototype.setRenderState.call(this, source, target, sourceRect, outRect, filterManager);
        var subtarget = this._hBlurTask.target;
        var secondPass = filterManager.popTemp(subtarget.width, subtarget.height);
        // emit real
        // crop a dest rectanle
        // ovveride blur target
        // we use a copyFrom, because if we will use referece - we can corrupt instance
        this._bevelTask.inputRect.copyFrom(this._vBlurTask.inputRect);
        this._bevelTask.destRect.copyFrom(outRect);
        //reset output size
        this._vBlurTask.inputRect.setTo(0, 0, 0, 0);
        this._vBlurTask.destRect.setTo(0, 0, 0, 0);
        // and reset target
        this._vBlurTask.target = secondPass;
        this._bevelTask.source = secondPass;
        this._bevelTask.sourceImage = source;
        this._bevelTask.target = target;
        this._temp.push(secondPass);
    };
    BevelFilter.filterName = 'bevel';
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "distance", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "angle", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "highlightColor", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "highlightAlpha", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "shadowColor", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "shadowAlpha", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "strength", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "type", void 0);
    __decorate([
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "knockout", void 0);
    return BevelFilter;
}(BlurFilter));
export { BevelFilter };
